import { create } from 'zustand';

export const useAgentSocketStore = create((set, get) => ({
    ws: null,
    status: 'idle',

    connect: (payload, displayLocation) => {
        if (get().ws?.readyState === WebSocket.OPEN) return;
        set({ status: 'connecting' });

        const ws = new WebSocket(process.env.REACT_APP_WSS_CHAT);

        ws.onopen = () => {
            set({ status: 'open' });
            ws.send(JSON.stringify(payload));
        }
        ws.onmessage = (event) => {
            const data = event.data ? JSON.parse(event.data) : null;
            if (!data) return;
            if (data.connectionId) {
                window.parent.postMessage({
                    type: 'connectionId',
                    connectionId: data.connectionId,
                }, '*');
            }
            if (data.type === 'floatingMessage' && displayLocation === data.displayLocation && data.message) {
                window.parent.postMessage({
                    type: 'floatingMessage',
                    floatingMessage: data.message,
                }, '*');
            }
        };
        ws.onerror = (e) => set({ status: 'error' });
        ws.onclose = () => set({ status: 'closed', ws: null });

        set({ ws });
    },

    send: (msg) => {
        const socket = get().ws;
        if (socket?.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify(msg));
        }
    },

    close: () => {
        get().ws?.close();
    },
}))